<div class="content-wrapper">
  <table
    *ngIf="support$ | async as support; else supportPlaceholder"
    class="table"
  >
    <tr *ngIf="showFAQ" class="row">
      <td class="label">{{ 'SUPPORT.FAQS' | translate }}</td>
      <td>
        <a
          [href]="supportUrl"
          class="standalone-link"
          target="_blank"
          rel="noopener"
          data-e2e-id="faqs"
          (click)="faqClick.emit()"
          >{{ 'SUPPORT.VISIT_HELP_PAGE' | translate }}</a
        >
      </td>
    </tr>
    <tr class="row">
      <td class="label">{{ 'SUPPORT.EMAIL' | translate }}</td>
      <td>
        <a
          href="mailto:{{ supportEmail }}"
          class="standalone-link"
          target="_blank"
          rel="noopener"
          data-e2e-id="email"
          (click)="emailClick.emit()"
          >{{ supportEmail }}</a
        >
      </td>
    </tr>
    <tr *ngIf="support.phoneSupport as phoneSupport" class="row">
      <td class="label">{{ phoneSupport.title }}</td>
      <td>
        <p class="phone-number">{{ phoneSupport.number }}</p>
        <p class="phone-notice">{{ phoneSupport.description }}</p>
      </td>
    </tr>
  </table>

  <ng-template #supportPlaceholder>
    <div class="support">
      <div *ngFor="let i of placeholderRows" class="row row-placeholder">
        <div class="label">
          <p class="column-placeholder shimmer"></p>
        </div>
        <div class="column-placeholder shimmer"></div>
      </div>
    </div>
  </ng-template>
</div>
